<template>
    <div class="widget-hotspots">
        <Widget
            :widget="widget"
            :hasHotspots="true"
            :hotspotsHidden="hotspotsHidden"
            @go-to-widget="goToWidget(widget)"
            @toggle-hotspots="toggleHotspot"
        />
        <v-expand-transition>
            <v-list
                v-show="!hotspotsHidden"
                class="mt-4 hotspot-list"
            >
                <v-list-item
                    v-for="(hotspot, index) in widget.hotspots"
                    :key="`hotspot-${index}`"
                    :class="{ 'active': widget.active && hotspot.active }"
                    :ripple="false"
                    v-show="!hiddenHotspotType.includes(hotspot.type)"
                    link
                >
                    <v-list-item-icon class="mx-3 my-1">
                        <v-img
                            :src="hotspotImg"
                            max-width="15"
                            contain
                        />
                    </v-list-item-icon>
                    <v-list-item-title
                        class="text-none"
                        v-text="hotspot.name"
                        @click.prevent="goToHotspot(widget, hotspot)"
                    />
                </v-list-item>
            </v-list>
        </v-expand-transition>
    </div>
</template>

<script>
    import { EventBus } from '@/event-bus';
    import { mapGetters } from 'vuex';
    import Widget from '@/components/sidebar/components/Widget';

    export default {
        name: 'WidgetWithHotspot',
        components: {
            Widget
        },
        props: {
            widget: {
                type: Object,
                required: true
            }
        },
        computed: {
            ...mapGetters('widget', [
                'requestedScene'
            ]),
            hasActiveHotspot() {
                return this.widget.hotspots.findIndex(hotspot => hotspot.active) !== -1;
            }
        },
        data: () => ({
            hotspotImg: require('@/assets/images/sidebar-color-pin.png'),
            hotspotsHidden: true,
            hiddenHotspotType: ['light-variation']
        }),
        methods: {
            goToWidget(widget) {
                this.$emit('go-to-widget', widget);
            },
            goToHotspot(widget, hotspot) {
                this.$emit('go-to-hotspot', widget, hotspot);
            },
            toggleHotspot() {
                if (this.hotspotsHidden) {
                    EventBus.$emit('HideHotspotsWidget');
                    this.hotspotsHidden = false;
                } else {
                    EventBus.$emit('HideHotspotsWidget');
                }
            }
        },
        mounted() {
            EventBus.$on('HideHotspotsWidget', () => this.hotspotsHidden = true);
        },
        watch: {
            requestedScene(newScene, lastScene) {
                if ((lastScene !== null && newScene !== null) && newScene !== lastScene) {
                    var hotspot = this.widget.hotspots.filter(hotspot => hotspot.scene === newScene);
                    if (hotspot.length)
                        this.$emit('go-to-hotspot', this.widget, hotspot[0]);
                }
            }
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/sidebar/components/WidgetWithHotspot.vue